import { useRef } from "react";

export default function useReCaptcha() {
  const reCaptchaRef = useRef();
  function triggerRecaptcha() {
    reCaptchaRef && reCaptchaRef.current && reCaptchaRef.current.execute();
  }
  return { reCaptchaRef, triggerRecaptcha };
}
